/**
 * Resolving the conversation language.
 *
 * The page already knows which language it is serving — `<html lang>` is required
 * by WCAG 3.1.1 and every serious multilingual site emits it correctly. Reading it
 * works with all four common multilingual strategies (path prefix, subdomain, query
 * parameter, cookie), whereas asking the customer to configure URL patterns breaks
 * on three of them and fails silently when the pattern is wrong.
 */

/** Normalise `en-US`, `ES`, `pt_BR` to the two-letter code the backend expects. */
export function normalise(value) {
  if (typeof value !== 'string') return null;
  const code = value.trim().toLowerCase().split(/[-_]/)[0];
  return /^[a-z]{2}$/.test(code) ? code : null;
}

/**
 * @param {HTMLScriptElement|null} script The tag that loaded the widget.
 * @param {Document} doc
 * @returns {string|null} Two-letter code, or null to let the backend fall back to
 *   the chatbot's configured default.
 */
export function detectLocale(script, doc = document) {
  // Explicit override, for customers who emit the tag dynamically.
  const declared = normalise(script?.dataset?.locale);
  if (declared) return declared;

  // What the page itself declares.
  const fromDocument = normalise(doc.documentElement?.lang);
  if (fromDocument) return fromDocument;

  return null;
}
